import React from "react";
import Marty from "marty";
import SubmitButton from "../../../../utils/components/SubmitButton";
import ValidatedForm from "../../../../utils/components/ValidatedForm";

let Cancel = React.createClass({
    cancelOrder(data, reset, invalidate) {
        this.app.userActions.cancelOrder(this.props.query, reset, invalidate);
    },
    componentWillMount() {
        this.app.navActions.hideBuyButton();
        this.app.navActions.hideHeader();
        this.app.navActions.hideFooter();
    },
    componentWillUnmount() {
        this.app.navActions.showBuyButton();
        this.app.navActions.showHeader();
        this.app.navActions.showFooter();
    },
    render() {
        const queryData = this.props.query;

        return (
            <section className="eo-view cancel">
                <div className="cancel-content">
                    <div className="cancel-inner">
                        { this.props.orderCancelledState ?
                            <div className="order-cancelled">
                                <h1 className="heading">Order cancelled.</h1>
                                <p>Your order has been cancelled. We hope to hear from you again soon.</p>
                            </div>
                            :
                            <div className="cancel-order">
                                <h1 className="heading">Changed your mind?</h1>
                                <div className="order">
                                    <p>Here is your order:</p>
                                    <div className="order-name grid-5 grid-s-10">
                                        <p><strong>{queryData.name}<br/>{queryData.email}</strong></p>
                                    </div>
                                    <div className="order-info grid-5 grid-s-10">
                                        <p><strong>
                                            Sales Order #: {queryData.otherrefnum}<br/>
                                            Purchase Order #: {queryData.recID}<br/>
                                            Items: {queryData.Products}<br/>
                                            Total: {queryData.Total}</strong>
                                        </p>
                                    </div>
                                    <p>We're sorry your order has been backordered. If you are unable to wait for your order to be filled, you may cancel your order now for a full refund.</p>
                                </div>
                                <ValidatedForm className="cancel-form" data={{}} handleSubmit={this.cancelOrder} confirm="Are you sure you want to cancel your order?">
                                    <SubmitButton className="cancel-order-submit" text="Cancel" submittingText="Cancelling" btnClassName=""/>
                                </ValidatedForm>
                            </div>
                        }
                    </div>
                </div>
            </section>
        );
    }
});


export default Marty.createContainer(Cancel, {
    listenTo: ["userStore"],
    fetch: {
        orderCancelledState() {
            return this.app.userStore.isOrderCancelled(this.props.query.recID);
        }
    }
});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/cancel/Handler.js
 **/